import BaseModel from './BaseModel';
import moment from 'moment';
import { CUSTOM_PRICE } from '../constants/Define';
import { getMomentDate } from './../utils/commonUtils';
export default class VinWonderPrice extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.vinWonderId = data.vinWonderId || undefined;
        this.name = data.name || undefined;
        this.setType(data.calculationType || undefined);
        this.value = data.calculationValue || 0;
        this.startDate = getMomentDate(data.startDate);
        this.endDate = getMomentDate(data.endDate);
    }

    
    setType(type) {
        if (!type) type = CUSTOM_PRICE.CALCULATE_TYPE.AMOUNT;
        this.type = CUSTOM_PRICE.CALCULATE_TYPE[type.toUpperCase()] || type;
    }

    export() {
        const result = super.export({
            id: this.id,
            vinWonderId: this.vinWonderId,
            name: this.name,
            calculationType: this.type,
            calculationValue: Number(this.value),
            startDate: this.startDate && (this.startDate).toISOString(),
            endDate: this.endDate && (this.endDate).toISOString(),
        });
        return result;
    }

}
